<template>
	<div class="mobile-menu">
		<overlay :open="open" @close="$emit('close')" />
		<transition name="drawer" appear>
			<div v-if="open" class="drawer">
				<button class="close" @click="$emit('close')">
					<i class="fal fa-times"></i>
				</button>
				<div class="floating-label-input search">
					<input
						type="search"
						id="search-input"
						placeholder="Search"
						@focus="setSearchOpen"
					/>
					<label for="search-input">
						<i class="fal fa-search"></i> {{ $translations.search.search }}
					</label>
				</div>

				<nav class="main-nav">
					<ul class="main-nav__list">
						<li
							v-for="(item, index) in menu"
							:key="index"
							class="main-nav__list__item"
						>
							<a :href="item.url">{{ item.title }}</a>
						</li>
					</ul>
				</nav>

				<nav class="actions">
					<a href="/account"><i class="fal fa-user"></i></a>
					<a href="#" @click.prevent="handleCartClick"
						><i class="fal fa-shopping-bag"></i
						><span class="cart-count" v-if="cartCount > 0">{{
							cartCount
						}}</span></a
					>
					<div class="locale-menu">
						<span class="chevron">
							<i class="fal fa-chevron-down" />
						</span>
						<select v-model="currentLocaleIndex">
							<option
								v-for="(locale, index) in locales"
								:value="index"
								:key="locale.handle"
							>
								{{ locale.title }}
							</option>
						</select>
					</div>
				</nav>

				<nav class="footer-menu">
					<ul class="footer-menu__list">
						<li
							v-for="(item, index) in footer"
							:key="index"
							class="footer-menu__top-item"
						>
							<a :href="item.url">{{ item.title }}</a>
							<ul
								v-if="item.sublinks && item.sublinks.length > 0"
								class="footer-menu__list footer-menu__list--sub"
							>
								<li
									v-for="(subitem, index) in item.sublinks"
									:key="index"
									class="footer-menu__sub-item"
								>
									<a :href="subitem.url">{{ subitem.title }}</a>
								</li>
							</ul>
						</li>
					</ul>
				</nav>

				<div class="social">
					<a href="#"><i class="fab fa-facebook-f"></i></a>
					<a href="#"><i class="fab fa-instagram"></i></a>
					<a href="#"><i class="fab fa-youtube"></i></a>
					<a href="#"><i class="fab fa-linkedin"></i></a>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import store from "../store";
import Overlay from "./overlay.vue";

export default {
	components: { Overlay },
	store,
	props: {
		open: {
			type: Boolean,
			required: true
		},
		menu: {
			type: Array,
			required: true
		},
		footer: {
			type: Array,
			required: true
		},
		locales: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			currentLocaleIndex: this.locales.findIndex(locale => locale.url === "/")
		};
	},
	computed: {
		...mapState({
			cartCount(state) {
				if (!state.cart) return 0;
				return state.cart.data.item_count;
			}
		})
	},
	methods: {
		...mapMutations({
			setSearchOpen: "search/open",
			setCartOpen: "cart/open"
		}),
		handleCartClick() {
			this.$emit("close");
			this.setCartOpen(true);
		},
		handleLocaleChange(locale) {
			console.log("handle locale change", locale);
		}
	},
	watch: {
		currentLocaleIndex() {
			const locale = this.locales[this.currentLocaleIndex];
			window.location = locale.url;
		}
	}
};
</script>

<style lang="scss" scoped>
.mobile-menu {
	a {
		color: black;
		padding: 0;
		text-decoration: none;
		&:hover {
			box-shadow: none;
		}
	}
	display: none;
	@include media($breakpoint-header-small) {
		display: block;
	}
}

.drawer {
	position: fixed;
	z-index: z-index(mobile-menu);
	top: 0;
	right: 0;
	max-width: 320px;
	width: 100%;
	height: 100vh;
	padding: 40px;
	background-color: white;
	box-shadow: -1px 0 2px 0 rgba(0, 0, 0, 0.05);
	overflow-y: scroll;

	&-enter-active,
	&-leave-active {
		transition: transform 0.3s ease-in-out;
	}

	&-enter,
	&-leave-to {
		transform: translateX(100%);
	}
}

.close {
	appearance: none;
	background-color: transparent;
	border: none;
	position: absolute;
	top: 40px;
	right: 40px;
}

.search {
	width: 175px;
}

.main-nav {
	&__list {
		margin: 40px 0 0 0;
		padding: 0;
		list-style: none;
		&__item {
			font-size: 18px;
			text-transform: uppercase;
			font-family: $font-family;
			letter-spacing: 2.33px;
			& + & {
				margin-top: 32px;
			}
		}
	}
}

.actions {
	margin-top: 72px;
	display: flex;
	font-size: 18px;

	a {
		position: relative;
	}

	> * + * {
		margin-left: 24px;
	}
}

.cart-count {
	pointer-events: none;
	position: absolute;
	bottom: -6px;
	right: -6px;
	width: 16px;
	height: 16px;
	background-color: $teal;
	border-radius: 8px;
	color: white;
	font-size: 10px;
	text-align: center;
	line-height: 16px;
}

.footer-menu {
	margin-top: 56px;

	.footer-menu__list {
		margin: 0;
		padding: 0;
		list-style: none;
		font-size: 18px;

		&--sub {
			margin-top: 24px;
		}
	}

	&__top-item {
		& > a {
			text-transform: uppercase;
			font-size: 14px;
			color: #99a29f;
			letter-spacing: 2px;
		}
		& + & {
			margin-top: 56px;
		}
	}

	&__sub-item {
		& + & {
			margin-top: 16px;
		}
	}
}

.social {
	margin-top: 48px;
	display: flex;
	* + * {
		margin-left: 24px;
	}
}

.locale-menu {
	position: relative;

	.chevron {
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);
		font-size: 12px;
	}

	select {
		margin-right: 8px;
		appearance: none;
		border: none;
		background-color: transparent;
		font-family: $font-family;
		font-size: 16px;
	}
}
</style>
